<template>
    <div class='col-sm-12'>
        <div :class="ingresado ? 'bg-primary' : pregunta.obligatoria ? 'obligatoria' : ''">
            <span v-if="muestraP">{{ pregunta.pregunta }}</span>
            {{ pregunta.literal }}
        </div>
        <input :disabled="ingresado" @change="creaEvaluacionDetalle()" v-model="valor" type='text' class='form-control' placeholder='Ingrese sólo letras y números' maxlength='6' />
        
    </div> 
</template>

<script>
    import moment from 'moment';

    export default {
        props: ['pregunta', 'evaluacion_id', 'muestraP'],
        data() {
            return {
                valor: null,
                ingresado: false
            }
        },
        methods: {
            creaEvaluacionDetalle() {
                axios.post('/api/evaluacion_detalle/' + this.evaluacion_id, 
                    {
                        'hora_ini_app' : moment().format('H:mm:ss'),
                        'preguntas_paso_servicio_id' : this.pregunta.id,
                        'pregunta_texto' : this.pregunta.pregunta,
                        'valor' : null,
                        'texto' : this.valor,
                        'completo' : true
                    }
                )
                .then(response => {
                    this.ingresado = true;
                    this.$emit('update:actualiza', response.data.data);

                })
                .catch(error => {
                    this.form.errors = ['Something went wrong. Please try again.'];
                });
            }
        },
    }
</script>

<style lang="scss" scoped>
    .obligatoria{
        background-color: #ff0000;
        color: #FFFFFF;
    }

    .bg-primary {
		background-color: #1ab394;
		border-color: #1ab394;
		color: #FFFFFF;
	}
</style>